var exports = {
  "kL": "x31de4314--d0729b--container",
  "yJ": "x31de4314--d0729b--links",
  "PD": "x31de4314--d0729b--links--expanded",
  "UI": "x31de4314--d0729b--links-block",
  "hJ": "x31de4314--d0729b--counter",
  "nf": "x31de4314--d0729b--link",
  "sY": "x31de4314--d0729b--full-list-hidden",
};

module.exports = exports;
